<template>
  <div class="card p-2">
    <div class="card-header">
      <h6 class="card-title">Video status</h6>
    </div>
    <div class="card-body">
      <div class="item-status">
        <div
          class="item-status__body d-flex align-items-center justify-content-between"
        >
          <div
            :class="[
              'item-status__icon ',
              status_changed == 1
                ? 'badge badge--success'
                : 'badge badge--warning',
            ]"
          >
            <i
              :class="[
                'fas',
                item.status == 1 ? 'fa-check-circle' : 'fa-cross-circle',
              ]"
            ></i>
            {{ status_changed === 1 ? 'Active' : 'No Active' }}
          </div>
          <div class="item-change-status">
            <label class="checkbox style-e">
              <input
                type="checkbox"
                v-model="status_changed"
                @change.prevent="handleChangeStatus"
              />
              <div class="checkbox__checkmark"></div>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      status_changed: this.item.status,
    };
  },
  methods: {
    async handleChangeStatus() {
      try {
        const res = await axios.post(`/creator/change-status/${this.item.id}`, {
          status: this.status_changed,
        });
        if (res.data.status) {
          notify('success', 'Status changed successfully!');
        }
      } catch (e) {
        console.error(e)
        notify('error', e.message);
      }
    },
  },
};
</script>

<style scoped>
.style-e {
  display: inline-block;
  position: relative;
  padding-left: 50px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.style-e input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.style-e input:checked ~ .checkbox__checkmark {
  background-color: #0f4c47;
}
.style-e input:checked ~ .checkbox__checkmark:after {
  left: 21px;
}
.style-e:hover input ~ .checkbox__checkmark {
  background-color: #eee;
}
.style-e:hover input:checked ~ .checkbox__checkmark {
  background-color: #0f4c47;
}
.style-e .checkbox__checkmark {
  position: absolute;
  top: 1px;
  left: 0;
  height: 22px;
  width: 40px;
  background-color: #eee;
  transition: background-color 0.25s ease;
  border-radius: 11px;
}
.style-e .checkbox__checkmark:after {
  content: '';
  position: absolute;
  left: 3px;
  top: 3px;
  width: 16px;
  height: 16px;
  display: block;
  background-color: #fff;
  border-radius: 50%;
  transition: left 0.25s ease;
}

.checkbox__body {
  color: #333;
  line-height: 1.4;
  transition: color 0.25s ease;
  margin-right: 10px;
}
.item-change-status .style-e .checkbox__checkmark {
  background-color: #0f4c47;
  top: -8px;
}
</style>
